import * as SliderPrimitive from "@radix-ui/react-slider"
import { Dispatch, SetStateAction } from "react"

const SliderBar = () => (
    <div className="absolute top-1/2 left-1/2 flex h-7 w-9 -translate-x-1/2 -translate-y-1/2 items-center justify-center space-x-0.5 bg-gray-shuttle">
        <span className="h-4 w-0.5 bg-gray-main" />
        <span className="h-4 w-0.5 bg-gray-main" />
        <span className="h-4 w-0.5 bg-gray-main" />
    </div>
)
export const PriceSlider = ({
    range,
    values,
    onUpdate,
    step,
    setDrag,
}: {
    step: number
    range: number[]
    values: number[]
    onUpdate: (values: ReadonlyArray<number>) => void
    setDrag: Dispatch<SetStateAction<boolean>>
}) => (
    <div className="px-4.5">
        <SliderPrimitive.Root
            className="relative flex h-[42px] w-full touch-none select-none items-center"
            value={values}
            min={range[0]}
            max={range[1]}
            step={step}
            onValueCommit={() => setDrag(false)}
            onValueChange={(v) => {
                setDrag(true)
                onUpdate(v)
            }}>
            <SliderPrimitive.Track className="w-full cursor-pointer">
                <div className="h-2.5 w-full grow overflow-hidden border border-gray-silver bg-white" />
            </SliderPrimitive.Track>
            <SliderPrimitive.Thumb className="relative flex h-0 w-0 cursor-pointer items-center justify-center focus-visible:outline-none">
                <SliderBar />
            </SliderPrimitive.Thumb>
            <SliderPrimitive.Thumb className="relative flex h-0 w-0 cursor-pointer items-center justify-center focus-visible:outline-none">
                <SliderBar />
            </SliderPrimitive.Thumb>
        </SliderPrimitive.Root>
    </div>
)
